<div class="modal-body after-login-popup">
       <div class="row">
        <div class="col-sm-12 col-lg-6">
        <img src="assets/images/popup-img.png" alt="" class="popupImg">
        </div>
        <div class="col-sm-12 col-lg-6 text-center lang-popup-text">
            <h2 class="lang-head-text">Please Choose Your <div class="lang-red-text">Preferable Language</div> </h2>
            <button type="button" class="btn btn-selected" (click)="chooseLanguage(false)">English</button>
            <span class="ortext"></span>
            <button type="button" class="btn" data-bs-dismiss="modal" (click)="chooseLanguage(true)">Arabic</button>
        </div>
    </div>
    </div>

